import cn from 'classnames';

import css from 'styles/components/checkout/caap/modalOverlay.scss';

const ModalOverlay = componentParams => {
  const {
    children,
    onCloseModalOverlayClick,
    showAsModal
  } = componentParams;

  const wrapperStyles = cn(css.modalWrapperContainer, { [css.modalWrapper]: showAsModal });
  const clickHandlerWrapperStyles = cn(css.hideSmallScreen, { [css.modalClickHandlerWrapper]: showAsModal });
  const modalStyles = cn({ [css.isModal]: showAsModal });

  return (
    <div className={wrapperStyles}>
      <div
        className={clickHandlerWrapperStyles}
        onClick={onCloseModalOverlayClick}
        onKeyPress={onCloseModalOverlayClick}
        role="button"
        tabIndex="0">
      </div>
      <div className={modalStyles}>
        {children}
      </div>
    </div>
  );
};

export default ModalOverlay;
